/** Fecha de HOY en hora LOCAL (yyyy-MM-dd).
 *
 * NO usar `new Date().toISOString().slice(0, 10)`: toISOString es UTC y en
 * Colombia (UTC-5) después de las 19:00 devuelve el día SIGUIENTE — bug
 * reportado por Rafael 2026-09-30 (el cierre de JV hecho a las 21:00 quedó
 * con fecha del día siguiente y por eso los abonos salieron en cero).
 */
export const hoyLocal = (): string => {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${dd}`
}
